import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import loadable from '@loadable/component';

import 'assets/css/pages/_our-story.scss';
import {
  fetchRegionalPrices,
  selectRegionalPricesStatus,
} from '../features/regionalPrices/regionalPricesSlice';
import { selectLocalizationData } from '../features/localization/localizationSlice';
import { STATUS } from '../../shared/enums';

import FallbackPlaceholder from '../components/common/FallbackPlaceholder';

const HeroBackgroundImage = loadable(() => import('../components/our-story/HeroBackgroundImage'));
const SbsicBlock = loadable(() => import('../components/our-story/SbsicBlock'));
const GridCard = loadable(() => import('../components/our-story/GridCard'));
const OverlayBlock = loadable(() => import('../components/our-story/OverlayBlock'));
const OrderBlock = loadable(() => import('../components/common/OrderBlock'));

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const OurStory = props => {
  const { route } = props;

  const dispatch = useDispatch();
  const localization = useSelector(selectLocalizationData);
  const status = useSelector(selectRegionalPricesStatus);
  const { PREFETCHED, SUCCEEDED } = STATUS;

  useEffect(() => {
    if (status === STATUS.IDLE) {
      dispatch(fetchRegionalPrices(localization));
    }
    return undefined;
  }, []);

  return (
    <>
      <Helmet>
        <title>{route?.meta?.title}</title>
        <meta name='title' content={ route?.meta?.title } />
        <meta name='description' content={route?.meta?.description} />
      </Helmet>
      <HeroBackgroundImage fallback={<FallbackPlaceholder />} />
      <SbsicBlock />
      <GridCard />
      <OverlayBlock />
      {[ PREFETCHED, SUCCEEDED ].includes(status) && (<OrderBlock />)}
    </>
  );
};


export default OurStory;
